import angular from 'angular'
import template from './template.html'

angular.module('nominas.informacionfiscal')
  .component('nominasInformacionfiscalEmpresasEmpresaDescargaArchivo', {
    bindings: {
      data: '<',
      index: '<',
      onChange: '&',
    },
    template: template,
    controller: Component,
  });

function Component($http, $q) {
  let $ctrl = this;

  $ctrl.$onInit = $onInit;
  $ctrl.$onDestroy = $onDestroy;

  function $onInit() {
    $ctrl.completado = false;
    $ctrl.documento = null;
    $ctrl.timeout = $q.defer();

    $http.get($ctrl.data.url, {
        params: $ctrl.data.params,
        timeout: $ctrl.timeout.promise,
        responseType: 'arraybuffer',
      })
      .then(function (response) {
        $ctrl.documento = {
          name: $ctrl.data.filename,
          contentType: response.headers('Content-Type'),
          content: response.data,
        };
      })
      .finally(function () {
        $ctrl.completado = true;
        $ctrl.onChange({$event: {data: $ctrl.documento}});
      });
  }

  function $onDestroy() {
    $ctrl.timeout.resolve();
  }
}



// WEBPACK FOOTER //
// ./src/nominas/informacionfiscal/components/empresas/empresa/descarga/archivo/component.js